var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    enableBackground: "new 0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M14.986,0c-0.56,0-1.012,0.454-1.012,1.013v2.362C12.832,1.992,11.516,0,7.894,0C3.542,0,0,3.541,0,7.894 s3.542,7.894,7.894,7.894c3.418,0,6.432-2.183,7.502-5.433c0.177-0.541-0.117-1.123-0.658-1.301 c-0.541-0.179-1.125,0.115-1.303,0.656c-0.789,2.4-3.017,4.014-5.542,4.014c-3.216,0-5.832-2.615-5.832-5.832s2.616-5.82,5.832-5.82 c2.277,0,3.542,1.417,4.574,2.903H9.921c-0.56,0-1.013,0.454-1.013,1.013c0,0.56,0.453,1.013,1.013,1.013h5.065 C15.546,7.004,16,6.55,16,5.991V1.013C16,0.454,15.546,0,14.986,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/Reload.843a8996d6b7dc3a269838cbe9437944.svg";
export { ForwardRef as ReactComponent };